







import { Vat, VatState } from '@/api';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class MilkVatInfoLine extends Vue {
	@Prop({ required: true, type: Object })
	private readonly vat!: Vat;

	public get id(): string {
		if (this.vat.id) {
			return this.vat.id.toString();
		}
		return 'No ID';
	}

	public get formula(): string {
		return this.vat.formula ?? 'No formula';
	}

	public get sizeString(): string {
		return this.vat.sizeString ?? 'No size';
	}

	public get state(): string {
		switch (this.vat.state) {
			case VatState.Supply: {
				return 'Currently Supplying';
			}
			case VatState.NonSupply: {
				return 'Non-supply';
			}
			case VatState.NotUsed: {
				return 'Not In Use';
			}
			default: {
				return 'No state';
			}
		}
	}
}
